(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../tab-bar/index", "../sticky/index", "../swiper/index", "../_mixins/tabBar"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../tab-bar/index"), require("../sticky/index"), require("../swiper/index"), require("../_mixins/tabBar"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.index, global.index, global.index, global.tabBar);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _index2, _index3, _index4, _tabBar) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _index2 = _interopRequireDefault(_index2);
  _index3 = _interopRequireDefault(_index3);
  _index4 = _interopRequireDefault(_index4);
  _tabBar = _interopRequireDefault(_tabBar);

  var _components;

  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-tabs-slide"
      }, [_vm.sticky ? [_vm.showTitleBar ? _c('nx-sticky', {
        ref: "sticky",
        attrs: {
          "offset": _vm.offset,
          "boundary": _vm.boundary
        },
        on: {
          "onScroll": _vm.handleScroll
        }
      }, [_vm.showTitleBar ? _c('nx-tab-bar', {
        ref: "tabBar",
        attrs: {
          "items": _vm.menus,
          "immediateAnimation": _vm.immediateAnimation,
          "bottomBorder": _vm.bottomBorder,
          "value": _vm.currentName,
          "has-ink": _vm.hasInk,
          "ink-length": _vm.inkLength,
          "immediate": _vm.immediate,
          "tabBarType": _vm.tabBarType,
          "ink-pos-radio": _vm.inkPosRadio,
          "inkColor": _vm.inkColor,
          "barBgColor": _vm.barBgColor,
          "selectColor": _vm.selectColor,
          "unSelectColor": _vm.unSelectColor,
          "isPrevent": _vm.isPrevent,
          "blurMaterial": _vm.blurMaterial,
          "tabBarStyle": _vm.tabBarStyleData
        },
        on: {
          "changeTabBarHeight": _vm.changeTabBarHeight,
          "change": _vm.$_handleTabClick
        }
      }) : _vm._e()], 1) : _vm._e()] : [_vm.showTitleBar ? _c('nx-tab-bar', {
        ref: "tabBar",
        attrs: {
          "items": _vm.menus,
          "immediateAnimation": _vm.immediateAnimation,
          "bottomBorder": _vm.bottomBorder,
          "value": _vm.currentName,
          "has-ink": _vm.hasInk,
          "ink-length": _vm.inkLength,
          "immediate": _vm.immediate,
          "tabBarType": _vm.tabBarType,
          "inkColor": _vm.inkColor,
          "barBgColor": _vm.barBgColor,
          "selectColor": _vm.selectColor,
          "unSelectColor": _vm.unSelectColor,
          "isPrevent": _vm.isPrevent,
          "blurMaterial": _vm.blurMaterial,
          "tabBarStyle": _vm.tabBarStyleData,
          "ink-pos-radio": _vm.inkPosRadio
        },
        on: {
          "changeTabBarHeight": _vm.changeTabBarHeight,
          "change": _vm.$_handleTabClick
        }
      }) : _vm._e()], _c('div', {
        staticClass: "nx-tabs-slide-content"
      }, [_c('nx-swiper', {
        ref: "swiper",
        attrs: {
          "hasDots": false,
          "default-index": _vm.swiperDefaultIndex,
          "autoplay": 0,
          "isLoop": false,
          "is-prevent": false,
          "useNative-driver": false,
          "isDragRebound": _vm.isDragRebound,
          "ariaSwiperFocus": false,
          "dragable": _vm.showTitleBar,
          "tabSlideMode": _vm.mode,
          "round": false,
          "animation": _vm.animation
        },
        on: {
          "before-change": _vm.beforeChange,
          "posChange": _vm.posChange,
          "after-change": _vm.afterChange
        }
      }, [_vm._t("default")], 2)], 1)], 2);
    },
    name: 'nx-tabs-slide',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _index2.default.name, _index2.default), (0, _defineProperty2.default)(_components, _index3.default.name, _index3.default), (0, _defineProperty2.default)(_components, _index4.default.name, _index4.default), _components),
    props: {
      value: String,
      hasInk: {
        type: Boolean,
        default: true
      },
      bottomBorder: {
        type: Boolean,
        default: true
      },
      inkLength: Number,
      immediate: Boolean,
      sticky: {
        type: Boolean,
        default: false
      },
      offset: {
        type: Number,
        default: 0
      },
      boundary: {
        type: String,
        default: ''
      },
      showTitleBar: {
        type: Boolean,
        default: true
      },
      tabBarType: {
        type: String,
        default: 'slide'
      },
      mode: {
        type: String,
        default: 'default'
      },
      immediateAnimation: {
        type: Boolean,
        default: true
      },
      isDragRebound: {
        type: Boolean,
        default: false
      },
      isPrevent: {
        type: Boolean,
        default: true
      },
      blurMaterial: {
        type: Boolean,
        default: false
      },
      animation: {
        type: String,
        default: 'tab-slide'
      }
    },
    mixins: [_tabBar.default],
    data: function data() {
      return {
        currentName: this.value,
        prevIndex: 0,
        panes: [],
        inkPosRadio: 0,
        swiperDefaultIndex: 0,
        isTabScroll: true,
        titleBarHeight: 50
      };
    },
    watch: {
      value: function value(_new, _old) {
        if (_new !== this.currentName) {
          this.$_handleTabClick({
            name: _new
          }, this.getIndex(_new), this.getIndex(_old));
        }
      }
    },
    computed: {
      menus: function menus() {
        return this.panes.map(function (pane) {
          return {
            name: pane.name,
            label: pane.label,
            disabled: pane.disabled
          };
        });
      },
      currentIndex: function currentIndex() {
        for (var i = 0, len = this.menus.length; i < len; i++) {
          if (this.menus[i].name === this.currentName) {
            return i;
          }
        }

        return 0;
      }
    },
    provide: function provide() {
      return {
        rootTabsSlide: this
      };
    },
    mounted: function mounted() {
      if (!this.currentName && this.menus.length) {
        this.currentName = this.menus[0].name;
      } // 先执行这行代码，再执行swiper的$_reInitItems方法


      this.swiperDefaultIndex = this.getIndex(this.currentName);
    },
    methods: {
      // MARK: private events
      $_handleTabClick: function $_handleTabClick() {
        var _this$panes$index, _this$$refs$swiper;

        var tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var prevIndex = arguments.length > 2 ? arguments[2] : undefined;
        var isSlide = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        this.currentName = tab.name || ((_this$panes$index = this.panes[index]) === null || _this$panes$index === void 0 ? void 0 : _this$panes$index.name);
        this.prevIndex = prevIndex;
        !isSlide && ((_this$$refs$swiper = this.$refs.swiper) === null || _this$$refs$swiper === void 0 ? void 0 : _this$$refs$swiper.goto(index));
        this.$emit('input', tab.name);
        this.$emit('change', tab);
      },
      beforeChange: function beforeChange(fromIndex, toIndex) {
        // 防止循环调用
        if (toIndex === this.currentIndex) return;
        this.$_handleTabClick(this.panes[toIndex], toIndex, fromIndex, true);
      },
      afterChange: function afterChange(fromIndex, toIndex) {
        this.$emit('afterChange', fromIndex, toIndex);
      },
      // MARK: private methods
      $_addPane: function $_addPane(pane) {
        if (this.panes.indexOf(pane) === -1) {
          this.panes.push(pane);
        }
      },
      $_removePane: function $_removePane(pane) {
        var index = this.panes.indexOf(pane);

        if (index >= 0) {
          this.panes.splice(index, 1);
        }
      },
      posChange: function posChange(pos) {
        this.inkPosRadio = pos;
      },
      reflowTabBar: function reflowTabBar() {
        var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.$refs.tabBar.reflow({
          animate: animate
        });
      },
      changeTabBarHeight: function changeTabBarHeight(height) {
        var _this$$refs$sticky,
            _this = this;

        (_this$$refs$sticky = this.$refs.sticky) === null || _this$$refs$sticky === void 0 ? void 0 : _this$$refs$sticky.reflow();
        this.titleBarHeight = height;
        this.panes.forEach(function (item) {
          item === null || item === void 0 ? void 0 : item.resetItemStyle({
            titleBarHeight: _this.titleBarHeight,
            isTabScroll: _this.isTabScroll
          });
        });
      },
      getIndex: function getIndex(name) {
        for (var i = 0, len = this.menus.length; i < len; i++) {
          if (this.menus[i].name === name) {
            return i;
          }
        }

        return 0;
      },
      handleScroll: function handleScroll(scrollTop, affixed) {
        this.tabBarStyleData = affixed ? this.tabBarStyleAffixed : this.tabBarStyle;
      }
    }
  };
  _exports.default = _default;
});